import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dev-fertilizer",
  "use": "icon-dev-fertilizer-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-dev-fertilizer\"><path d=\"M123.39,211.57,90.6,132.4,11.43,99.61l152.82-63.3a17.17,17.17,0,0,1,22.44,22.44h0ZM35,99.61l62.54,25.9,25.9,62.54,55-132.74a8.17,8.17,0,0,0-10.68-10.68Z\" /><rect x=\"85.99\" y=\"105.01\" width=\"55\" height=\"9\" transform=\"translate(-44.2 112.32) rotate(-45)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol